const canvas = document.getElementById('snow');
const ctx = canvas.getContext('2d');
let width, height, particles = [];

function resizeCanvas() {
  width = canvas.width = canvas.offsetWidth;
  height = canvas.height = canvas.offsetHeight;

  const area = width * height;
  const targetCount = Math.floor(area / 1000); // your chosen density

  // Adjust particle count dynamically without resetting everything
  if (particles.length < targetCount) {
    // Add new particles if needed
    const countToAdd = targetCount - particles.length;
    for (let i = 0; i < countToAdd; i++) {
      const size = Math.pow(Math.random(), 1.5) * 3 + 0.5;
      particles.push({
        x: Math.random() * width,
        y: Math.random() * height,
        r: size,
        speedY: 0.3 + Math.random() * 0.7,
        drift: Math.random() * 0.5 - 0.25,
        opacity: 0.4 + Math.random() * 0.6
      });
    }
  } else if (particles.length > targetCount) {
    // Remove extras
    particles.length = targetCount;
  }
}

window.addEventListener('resize', resizeCanvas);
resizeCanvas();

function draw() {
  ctx.clearRect(0, 0, width, height);

  for (const p of particles) {
    ctx.beginPath();
    ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
    ctx.fillStyle = `rgba(255, 255, 255, ${p.opacity})`;
    ctx.fill();

    p.y += p.speedY;
    p.x += p.drift;

    // reset snowflake when it falls out of view
    if (p.y > height + 2) {
      p.y = -5;
      p.x = Math.random() * width;
    }
    if (p.x < -5 || p.x > width + 5) {
      p.x = Math.random() * width;
      p.y = Math.random() * height;
    }
  }

  requestAnimationFrame(draw);
}

draw();